import { CompositionDetails } from "../composition-types";
import { compositionIds } from "../composition-ids";

export const mainBinGurDekhe: CompositionDetails = {
    id: compositionIds.mainBinGurDekhe,
    media: {
        youtubeVideoId: "X41rshFlhpI",
    },
    displayName: "Main Bin Gur Dekhe - Nirbhai Singh Jiinder Singh Ji",
    taals: ["kehrava"],
};
